import React, { useEffect } from "react";
import About from "../components/About/About";
import Contact from "../components/Contact/Contact";
import Hero from "../components/Hero/Hero";
import Video from "../components/Video/Video";
import Slider from "../components/Slider/Slider";
import ReactGA from "react-ga";

const Homepage = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  });
  return (
    <>
      <Hero />
      <About />
      <Slider />
      <Video />
      <Contact />
    </>
  );
};

export default Homepage;
